import { InjectionKey, reactive, readonly } from '@vue/composition-api'
import { Store } from '../types/store'
import Blockly from 'blockly'

interface InterfaceState {
  outputs: string[]
  qrCode: string
  blocks: string
  predictedPoses: string[]
  cameraMode: 'rear' | 'front'
  blocklyTheme: Blockly.Theme | null
}

const state = reactive<InterfaceState>({
  outputs: [],
  qrCode: '',
  blocks: '',
  predictedPoses: [],
  cameraMode: 'front',
  blocklyTheme: null,
})

const setOutputs = (o: string[]): void => {
  state.outputs = o
}

const setQrCode = (qrCode: string): void => {
  state.qrCode = qrCode
}

const setBlocks = (blocks: string): void => {
  state.blocks = blocks
}

const setPredictedPoses = (predictedPoses: string[]): void => {
  state.predictedPoses = predictedPoses
}

const setcameraMode = (mode: 'rear' | 'front'): void => {
  state.cameraMode = mode
}

const isRearCamera = (): boolean => {
  return state.cameraMode == 'rear'
}

const switchCameraMode = () => {
  if (state.cameraMode == 'front') {
    state.cameraMode = 'rear'
  } else {
    state.cameraMode = 'front'
  }
}

const setBlocklyTheme = (blocklyTheme: Blockly.Theme): void => {
  state.blocklyTheme = blocklyTheme
}

export default {
  state: readonly(state),
  setOutputs,
  setQrCode,
  setBlocks,
  setPredictedPoses,
  setcameraMode,
  isRearCamera,
  switchCameraMode,
  setBlocklyTheme,
}

export const key: InjectionKey<Store> = Symbol('key')
